/* eslint-disable @typescript-eslint/no-unsafe-return */
import type { MultilingualNodeConfig, NodeConfig } from "../../schemas/index.ts";
import { isMultilingualProperty } from "./filterFunctions.ts";

type Options = { lang: string };

export const mergeNodeConfigToMultilingual = (
  originalConfig: MultilingualNodeConfig,
  newPartialConfig: NodeConfig,
  { lang }: Options,
): MultilingualNodeConfig => {
  const mergeProperties = (
    origCfg: MultilingualNodeConfig,
    newCfg: NodeConfig,
    depth: number = 0,
  ): MultilingualNodeConfig => ({
    ...newCfg,
    ...Object.fromEntries(
      Object.entries(origCfg)
        .map(([name, value]) => {
          if (!(name in newCfg)) {
            // Shallow merge. Matches react setState and any deeper is complex for consumers
            // having to set every nested property to undefined to remove it.
            return depth > 0 ? [name, undefined] : [name, value];
          }
          const newValue = newCfg[name];
          if (isMultilingualProperty(value)) {
            return [name, { __ml: { ...value.__ml, [lang]: newValue } }];
          }
          if (!!value && typeof value === "object" && !Array.isArray(value)) {
            if (newValue === null || typeof newValue !== "object" || Array.isArray(newValue)) {
              return [name, newValue];
            }
            return [name, mergeProperties(value, newValue, depth + 1)];
          }
          return [name, newValue];
        })
        .filter(([_, value]) => value !== undefined),
    ),
  });

  return mergeProperties(originalConfig, newPartialConfig);
};
